(function () {
  function initShowcase(root) {
    if (root.dataset.showcaseReady) return;
    root.dataset.showcaseReady = 'true';

    var tabs = root.querySelectorAll('[data-tab]');
    var slides = root.querySelectorAll('[data-tab-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        if (tab.classList.contains('is-active')) return;

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-tab-panel') === target);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mormaii-app-showcase]').forEach(initShowcase);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  init();
})();
